import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getProductStockTransfersDetailFetchSuccess, getProductStockTransfersDetailFetchFailure } from './reducer';
import { ProductStockTransfersDetailResType } from 'src/types/productStockTransfersDetail';

const getProductStockTransfersDetailFetchRequest = async (idProduct: string) => {
    const res = await api('get', `api/secure/products/stockTransfers/${idProduct}`);
    return res.data.data;
};

function* getProductStockTransfersDetailFetch(action: { type: string; payload: string }) {
    try {
        const response: ProductStockTransfersDetailResType = yield call((): any =>
            getProductStockTransfersDetailFetchRequest(action.payload)
        );
        yield put(getProductStockTransfersDetailFetchSuccess(response));
    } catch (error) {
        yield put(getProductStockTransfersDetailFetchFailure({ error }));
    }
}

export function* getProductStockTransfersDetailFetchWatch() {
    yield takeEvery(
        'productStockTransfersDetail/getProductStockTransfersDetailFetch',
        getProductStockTransfersDetailFetch
    );
}
